<template>
  <div class="coming-soon-integrations-section" data-testid="coming-soon-section">
    <h2 class="section-title">Coming Soon</h2>
    <p class="text-sm text-zinc-600 dark:text-zinc-400 mb-6">Request these integrations to help us prioritize development.</p>

    <div class="integrations-grid">
      <ComingSoonIntegrationCard
        v-for="integration in sortedComingSoonIntegrations"
        :key="integration.name"
        :integration="integration"
        @request-integration="handleRequestIntegration"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ComingSoonIntegrationCard from '../cards/ComingSoonIntegrationCard.vue';
import { useIntegrationStore } from '../../store/useIntegrationStore';
import { useTrack, TrackEvents } from '@/composables/useTrack';
import { useToast } from '@/composables/useToast';
import { storeToRefs } from 'pinia';

const integrationStore = useIntegrationStore();
const { track } = useTrack();
const { success } = useToast();

const { sortedComingSoonIntegrations } = storeToRefs(integrationStore);

const trackIntegrationClick = (integrationName: string, comingSoon: boolean = false) => {
  track(TrackEvents.INTEGRATIONS_SETUP, {
    app: integrationName,
    coming_soon: comingSoon,
    setup_requested: false,
  });
};

const handleRequestIntegration = (integrationName: string) => {
  track(TrackEvents.INTEGRATIONS_SETUP, {
    app: integrationName,
    coming_soon: true,
    setup_requested: true,
  });
  success(`Thanks for your interest in ${integrationName}! We've recorded your request and will prioritize development based on demand.`, {
    title: 'Integration Request Submitted',
  });
};
</script>

<style scoped>
.coming-soon-integrations-section {
  @apply mt-8 pt-8 border-t border-slate-300 dark:border-zinc-700;
}

.section-title {
  @apply text-xl font-semibold mb-3;
}

.integrations-grid {
  @apply grid gap-6 mt-4;
  @apply grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}
</style>
